'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET = exports.GET = 'get';
var POST = exports.POST = 'post';
var PUT = exports.PUT = 'put';
var PATCH = exports.PATCH = 'patch';
var DELETE = exports.DELETE = 'delete';
var HEAD = exports.HEAD = 'head';


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/fetchHelper/consts/httpMethods.js
// module id = woXg
// module chunks = 4